import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCurrentUser,
  resetFilters,
  searchClients,
  searchClientsByFilters
} from "./redux/clientProfileSearchSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import NoData from "../../../components/noData/noData";
import TableWithCustomSearch from "../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import { DatePicker } from "./smartComponents/DatePicker";
import { Dropdown } from "./smartComponents/Dropdown";

const ClientProfileSearchModule = (props) => {
  const dispatch = useDispatch();

  const {
    searchResults: {
      tableInfo: { data, colHeaders, columns, links }
    },

    tableLoading,
    filtersDirty,
    isLoading
  } = useSelector((state) => state.clientProfilesSearch);

  const [searchVal, setSearchVal] = useState("");
  const [displayVal, setDisplayVal] = useState("");

  useEffect(() => {
    dispatch(fetchCurrentUser(props));
  }, []);

  const handleChange = (event) => {
    let value = event.target.value.replace(/\s+/g, " ");

    if (value === " " && searchVal === "") value = "";
    setSearchVal(value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let trimmedValue = searchVal.trim();

    if (trimmedValue !== "") {
      setDisplayVal(trimmedValue);
      dispatch(searchClients(trimmedValue));
    }
  };

  const renderTable = () => {
    if (data) {
      return data.length ? (
        <TableWithCustomSearch
          itemsPerPage={15}
          fileName="profiles"
          data={data}
          columns={columns}
          links={links}
          colHeaders={colHeaders}
        />
      ) : (
        <NoData size="medium" />
      );
    }
  };

  const onUpdate = () => {
    setSearchVal("");
    setDisplayVal("");
    dispatch(searchClientsByFilters());
  };

  const onReset = () => {
    setSearchVal("");
    setDisplayVal("");
    dispatch(resetFilters());
  };

  const renderUpdateBtn = () => {
    return (
      <div className="action-buttons">
        {filtersDirty ? (
          <>
            <button className="submit" onClick={onUpdate}>
              Update
            </button>
            <button className="submit reset" onClick={onReset}>
              Reset
            </button>
          </>
        ) : null}
      </div>
    );
  };

  const updateButtons = renderUpdateBtn();

  if (isLoading) return <LoadingAnimation />;

  return (
    <div className="client-profile-search">
      <div className="client-profile-search__top">
        <div className="search-input">
          <div className="search-title">
            {data ? (
              <p>
                Displaying the top {data.length} results {displayVal ? "for " + displayVal : ""}
              </p>
            ) : (
              <p>Search for user by name or email</p>
            )}
          </div>
          <div>
            <form onSubmit={handleSubmit}>
              <input className="text" type="text" value={searchVal} onChange={handleChange} />
              <input className="submit" type="submit" value="GO!" />
            </form>
          </div>
        </div>

        <div className="search-filters">
          <div className="search-filters__top">
            <DatePicker title="Profile Created" slice="profileCreatedDate" />
            <DatePicker title="First Visit Date" slice="firstVisitDate" />
          </div>
          <div className="search-filters__bottom">
            <Dropdown title="Client Profile Status" slice="profile_statuses" />
            <Dropdown title="Membership Type" slice="membership_types" />
            <Dropdown title="Lead Type" slice="lead_types" />
            {updateButtons}
          </div>
        </div>
      </div>
      <div className="client-profile-search__bottom">
        <div>{tableLoading ? <LoadingAnimation /> : renderTable()}</div>
      </div>
    </div>
  );
};

export default ClientProfileSearchModule;
